export const HO_SO_BENH_AN_FORM = {
	TRANG_1: 'medicalRecordPage1',
	TRANG_A: 'medicalRecordMain',
	TRANG_TONG_KET: 'medicalRecordConclusion',
	TRANG_BIA: 'medicalRecordCoverPage',
};

export const DAC_DIEM_LIEN_QUAN_BENH_FIELDS = [
	'medicalHistoryAlcohol',
	'medicalHistoryAlcoholMonth',
	'medicalHistoryAllergy',
	'medicalHistoryAllergyMonth',
	'medicalHistoryDrug',
	'medicalHistoryDrugMonth',
	'medicalHistoryOther',
	'medicalHistoryOtherMonth',
	'medicalHistoryStrongTobacco',
	'medicalHistoryStrongTobaccoMonth',
	'medicalHistoryTobacco',
	'medicalHistoryTobaccoMonth',
];

export const SINH_HIEU_FIELDS = ['pr', 'bt', 'bpSys', 'bpDia', 'rr', 'height', 'weight'];